import { Component, OnInit, Input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormGroup, FormControl, Validators, ControlValueAccessor, NG_VALUE_ACCESSOR, AbstractControl, ValidatorFn } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'app-calendar-month',
  templateUrl: './calendar-month.component.html',
  styleUrls: ['./calendar-month.component.scss']
})
export class CalendarMonthComponent implements OnInit {

  _month: Date;
  monthLabel: string;
  days: any[];
  weeks: any[];
  _selectedDates: Date[];

  @Input()
  set month(property: Date) {
    this._month = property;
    this.render()

  }
  get month(): Date { return this._month; }



  @Input() parentForm: FormGroup;

  @Input()
  set selectedDates(property: Date[]) {
    this._selectedDates = property;
    this.render()
  }
  get selectedDates(): Date[] { return this._selectedDates; }

  constructor() {
  }

  ngOnInit() {
  }

  render(): any {
    this.monthLabel = `${this._month.toLocaleString("en-IE", { month: "long" })} ${this._month.getFullYear()}`;

    var days = []
    var weeks = []
    var month = this._month.getMonth()
    var currentDate = new Date(this._month.getFullYear(), this._month.getMonth(), 1);
    var today = new Date();
    today.setHours(0, 0, 0, 0);

    var monthEnd = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
    // first we need to reset back to monday
    while (currentDate.getDay() > 0) {
      currentDate.setDate(currentDate.getDate() - 1);
    }

    while (currentDate < monthEnd) {
      days.push({
        date: new Date(currentDate),
        day: currentDate.getDate(),
        isThisMonth: currentDate.getMonth() == month,
        isPast: currentDate < today
      })
      currentDate.setDate(currentDate.getDate() + 1);
    }

    var currentWeek = []
    for (var i = 0; i < days.length; i++) {

      if (currentWeek.length == 7) {
        weeks.push(currentWeek);
        currentWeek = [];
      }
      currentWeek.push(days[i])
    }
    if (currentWeek.length > 0)
      weeks.push(currentWeek);
    this.weeks = weeks;
    this.days = days;
  }





  toggleDay(day: any) {
    if (!this.selectedDates)
      this.selectedDates = [];

    if (day.date < new Date(new Date().setHours(0, 0, 0, 0)))
      return;

    var existing = this.selectedDates.find(p => p.getDate() == day.date.getDate() && p.getMonth() == day.date.getMonth() && p.getFullYear() == day.date.getFullYear());

    if (!existing) {
      let dateStr = `${day.date.getFullYear()}-${("0" + (day.date.getMonth() + 1)).slice(-2)}-${("0" + day.date.getDate()).slice(-2)}T00:00:00.000Z`;
      let dateConverted = new Date(dateStr);
      this.selectedDates.push(dateConverted);
      this.selectedDates.sort((a, b) => a.getTime() - b.getTime());
    }
    else {
      var index = this.selectedDates.indexOf(existing);
      this.selectedDates.splice(index, 1);
    }

    this.parentForm.get('eventDates').setValue(this.selectedDates);
  }

  isSelected(day: any) {
    if (this.selectedDates)
      return this.selectedDates.some(p => p.getDate() == day.date.getDate() && p.getMonth() == day.date.getMonth() && p.getFullYear() == day.date.getFullYear());
    return false;
  }

  convertToDate(date: any, time: any = null): Date {
    var retVal: Date = null;
    if (date instanceof Date) {
      // We want a clone here
      retVal = new Date(date.toISOString());
    }

    retVal = new Date(date);

    if (time) {
      var h = time ? time.split(':')[0] : null;
      var m = time ? time.split(':')[1] : null;

      retVal.setHours(h);
      retVal.setMinutes(m);
    }
    return retVal;

  }
}